import { VisualizationModule } from '@core/models/data-visualization/data-visualization.model';
import { CustomData } from '@core/models/entities/implementations/custom-data';

import { FilterDataType } from '@shared/components/filter-query-builder/filter.models';

import {
  AuxiliaryDataFetchDetails,
  EntityCfg,
  EntityInterface,
  TableColCfg
} from '../entity-visualization-interface';

export interface UserFlowKindV1Model {
  uid: string;
  name: string;
  custom_data: CustomData;
}
type RawModel = UserFlowKindV1Model;

export class UserFlowKindCfg implements EntityCfg<RawModel> {
  static readonly visus = new Set<VisualizationModule>([]);

  supportedVisualizations(): Set<VisualizationModule> {
    return UserFlowKindCfg.visus;
  }

  versionName(): string {
    return 'UserFlowKind';
  }

  defaultSortingCol(): string[] {
    return ['name'];
  }

  availableDetailEntityType(): string[] {
    return [];
  }

  makeAuxDataFetchDetails(_entities: RawModel[]): AuxiliaryDataFetchDetails {
    return {
      versionNameAndUidsPerType: {}
    };
  }

  buildColumns(): TableColCfg<EntityInterface<RawModel>>[] {
    const cols: TableColCfg<EntityInterface<RawModel>>[] = [
      {
        key: 'raw.uid' as keyof EntityInterface<RawModel>,
        label: 'table.columns.uid',
        type: 'string',
        cellTemplate: 'default',
        sortCfg: { dbColName: 'uid' },
        filterCfg: {
          translationLabel: 'uid',
          dbColName: 'uid',
          filterType: FilterDataType.TEXT
        }
      },
      {
        key: 'raw.name' as keyof EntityInterface<RawModel>,
        label: 'table.columns.name',
        type: 'string',
        cellTemplate: 'default',
        sortCfg: { dbColName: 'name' },
        filterCfg: {
          translationLabel: 'name',
          dbColName: 'name',
          filterType: FilterDataType.TEXT,
          supportRegexFiltering: true
        }
      },
      {
        key: 'raw.custom_data.tags' as keyof EntityInterface<RawModel>,
        label: 'table.columns.tags',
        type: 'uid-list',
        filterCfg: {
          translationLabel: 'tags',
          dbColName: 'tags',
          filterType: FilterDataType.TAGS
        }
      },
      {
        key: 'raw.custom_data.labels' as keyof EntityInterface<RawModel>,
        label: 'table.columns.custom_labels',
        type: 'string-number-map',
        filterCfg: {
          translationLabel: 'custom_labels',
          dbColName: 'labels',
          filterType: FilterDataType.LABELS
        }
      }
    ];

    return cols;
  }
}

export class UserFlowKindV1 implements EntityInterface<RawModel> {
  constructor(public raw: RawModel) {}

  supportedVisualizations(): Set<VisualizationModule> {
    return UserFlowKindCfg.visus;
  }

  get uid(): string {
    return this.raw.uid;
  }

  getDetailsCfg(): EntityCfg<unknown> | undefined {
    return undefined;
  }

  getDetails(): EntityInterface<unknown>[] {
    return [];
  }
}
